import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, financingCompanyId) {
  return apiFetch({ endPoint: 'FinanceCompany/DeleteCompantyFromUo/' + financingCompanyId + '/' + organizedUnitId, method: 'DELETE', body: null, token: token })
}
